import './assets/main.css'

import { ViteSSG } from 'vite-ssg'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import ToastService from 'primevue/toastservice'
import { useLanguageStore } from './stores/language'

import App from './App.vue'
import { routes } from './router'

export async function includedRoutes(paths: string[]) {
  return [
    '/',
    '/ozel-yazilim-gelistirme',
    '/about',
    '/contact',
    '/quote',
    '/privacy-policy',
    '/projects',
    '/references',
    '/blog',
    '/faq',
    '/delete-account',
    '/stuby-privacy-policy',
    '/ilac-saati-privacy-policy',
    '/ilac-saati-terms',
    '/projects/ots',
    '/projects/elestir',
    '/projects/stuby',
    '/projects/ilac-saati',
    '/projects/dunya-evim',
    '/projects/battleship',
    '/projects/csv-formatter',
    '/blog/sirketiniz-icin-ozel-yazilim-gelistirmenin-avantajlari',
    '/blog/mobil-uygulamalar-isletme-satislarini-nasil-artirir',
    '/blog/isletmeler-icin-yapay-zeka-verimlilik',
    '/blog/yazilim-projelerinde-outsourcing-faydalari',
    '/blog/ux-tasarimi-ve-donusum-oranlari',
    '/blog/web-sitesi-hizi-ve-seo-iliskisi',
    '/blog/siparis-takip-programi-ots-butik-satisi',
    '/blog/bulut-bilisim-cozumleri-ve-avantajlari',
    '/blog/basarili-eticaret-altyapisi-kurmanin-sirlari',
    '/blog/api-entegrasyonlari-ile-is-sureclerini-otomatize-edin',
    '/blog/geleneksel-cari-hesap-yonetiminin-zararlari-ve-dijital-cozumler',
    '/blog/siparis-karmasikligi-bolge-ve-personel-takibi',
    '/blog/isletmelerde-kusursuz-urun-stok-takibi',
    '/blog/e-ticarette-urun-gorsellerinin-satin-alma-ve-seo-etkisi',
    '/blog/sirket-ici-yazilimlar-operasyonel-verimlilik-intranet',
    '/blog/ozel-sirket-yazilimi-kurumsal-stratejik-avantajlar',
    '/blog/sirket-ici-surec-otomasyonu-ve-yonetici-dashboard',
    '/blog/b2b-bayi-tedarikci-portali-dijitallesme',
    '/blog/kurumsal-ik-ve-personel-gorev-takip-sistemleri',
    '/blog/neden-bulut-bilisim-hiz-faktoru-ve-avantajlari',
    '/blog/bulut-tabanli-cloud-native-ozel-yazilim-mimarisi',
    '/blog/sirketler-icin-buluta-gecis-cloud-migration-rehberi',
    // English
    '/en',
    '/en/custom-software',
    '/en/about',
    '/en/contact',
    '/en/quote',
    '/en/privacy-policy',
    '/en/projects',
    '/en/references',
    '/en/blog',
    '/en/faq',
    '/en/delete-account',
    '/en/stuby-privacy-policy',
    '/en/ilac-saati-privacy-policy',
    '/en/ilac-saati-terms',
    '/en/projects/ots',
    '/en/projects/elestir',
    '/en/projects/stuby',
    '/en/projects/ilac-saati',
    '/en/projects/dunya-evim',
    '/en/projects/battleship',
    '/en/projects/csv-formatter',
    '/en/blog/sirketiniz-icin-ozel-yazilim-gelistirmenin-avantajlari',
    '/en/blog/mobil-uygulamalar-isletme-satislarini-nasil-artirir',
    '/en/blog/isletmeler-icin-yapay-zeka-verimlilik',
    '/en/blog/yazilim-projelerinde-outsourcing-faydalari',
    '/en/blog/ux-tasarimi-ve-donusum-oranlari',
    '/en/blog/web-sitesi-hizi-ve-seo-iliskisi',
    '/en/blog/siparis-takip-programi-ots-butik-satisi',
    '/en/blog/bulut-bilisim-cozumleri-ve-avantajlari',
    '/en/blog/basarili-eticaret-altyapisi-kurmanin-sirlari',
    '/en/blog/api-entegrasyonlari-ile-is-sureclerini-otomatize-edin',
    '/en/blog/geleneksel-cari-hesap-yonetiminin-zararlari-ve-dijital-cozumler',
    '/en/blog/siparis-karmasikligi-bolge-ve-personel-takibi',
    '/en/blog/isletmelerde-kusursuz-urun-stok-takibi',
    '/en/blog/e-ticarette-urun-gorsellerinin-satin-alma-ve-seo-etkisi',
    '/en/blog/sirket-ici-yazilimlar-operasyonel-verimlilik-intranet',
    '/en/blog/ozel-sirket-yazilimi-kurumsal-stratejik-avantajlar',
    '/en/blog/sirket-ici-surec-otomasyonu-ve-yonetici-dashboard',
    '/en/blog/b2b-bayi-tedarikci-portali-dijitallesme',
    '/en/blog/kurumsal-ik-ve-personel-gorev-takip-sistemleri',
    '/en/blog/neden-bulut-bilisim-hiz-faktoru-ve-avantajlari',
    '/en/blog/bulut-tabanli-cloud-native-ozel-yazilim-mimarisi',
    '/en/blog/sirketler-icin-buluta-gecis-cloud-migration-rehberi',
  ]
}

export const createApp = ViteSSG(
  App,
  { routes },
  ({ app, router, isClient, initialState }) => {
    const pinia = createPinia()
    app.use(pinia)
    app.use(ToastService)
    app.use(PrimeVue, {
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: '.app-dark',
          cssLayer: false,
        },
      },
    })

    router.beforeEach((to, _from, next) => {
      const languageStore = useLanguageStore(pinia)
      const isEnglish = to.path === '/en' || to.path.startsWith('/en/')
      if (isEnglish) {
        if (languageStore.currentLanguage !== 'en') {
          languageStore.setLanguage('en')
        }
      } else {
        if (languageStore.currentLanguage !== 'tr') {
          languageStore.setLanguage('tr')
        }
      }
      next()
    })
  },
)
